import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiscogsComponent } from './simple-icons-discogs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiscogsComponent ],
    exports:      [ SimpleIconsDiscogsComponent ],
    bootstrap:    []
})
export class SimpleIconsDiscogsModule {}
